<script>
import PrimaryButton from './Button.vue';
import MediaForm from '../jobs/components/MediaForm.vue';
import event from '../event';

export default {
    name: 'MediaTabs',

    props: ["color"],

    components: { PrimaryButton, MediaForm },

    data() {
        return {
            activeTab: 'application',
            viewAtTopOfPage: true,
            debouncedWidth: 0,
            widthTimeout: null,
        }
    },

    computed: {
        cssVars() {
            return {
                '--company-color': this.color,
            }
        },
        width: {
            get() {
                return this.debouncedWidth;
            },
            set(val) {
                if (this.widthTimeout) clearTimeout(this.widthTimeout);
                this.widthTimeout = setTimeout(() => {
                    this.debouncedWidth = val;
                    this.handleCompanyColorOnMedia();
                }, 50);
            },
        },
        isApplicationTab() {
            return this.activeTab === 'application'
        },
        isDetailsTab() {
            return this.activeTab === 'details'
        },
        isApplicationInfo() {
            return this.activeTab === 'application_info';
        },
    },

    beforeMount() {
        window.addEventListener("scroll", this.handleUserScrolls);
    },

    mounted() {
        this.width = window.innerWidth;

        if(this.isApplicationTab) {
            this.$refs.btnGetConnected.classList.add('hidden')
        }

        this.handleCompanyColorOnMedia();
    },

    created() {
        window.addEventListener("resize", this.myEventHandler);

        event.bus.$on('media_form_height', function (value) {
            // 104 is the spacing from the top to the media form;
            document.getElementById("jobs-media-show-wrap").style.minHeight = (value + 104) + 'px';
        });
    },

    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },

    methods: {
        handleUserScrolls(){
            // User Scrolling To and Away from Top
            if(window.pageYOffset > 0){
                if(this.viewAtTopOfPage) this.viewAtTopOfPage = false;
            }else{
                if(!this.viewAtTopOfPage) this.viewAtTopOfPage = true;
            }
        },

        myEventHandler(e) {
            this.width = window.innerWidth;
        },

        selectTab(selectedTabName) {
            this.activeTab = selectedTabName;

            if (this.isApplicationTab) {
                this.$refs.btnGetConnected.classList.add('hidden');
                this.$refs.btnGetConnected.classList.remove('scrolling');
            }

            if (this.isDetailsTab || this.isApplicationInfo) {
                this.$refs.btnGetConnected.classList.remove('hidden');
                this.$refs.btnGetConnected.classList.add('scrolling');
                this.handleCompanyColorOnMedia();
            }
        },

        switchToApplicationTab() {
            setTimeout(() => {
                this.$refs.btnGetConnected.classList.add('hidden');
                this.activeTab = 'application';
                window.scrollTo({ top: 0, behavior: 'instant', }); //without scroll
                this.focusFirstInput();
            }, 100)
        },

        focusFirstInput() {
            this.$nextTick(() => {
                document.querySelectorAll('input')[0].focus()
            })
        },

        scrollToFullForm() {
            if (this.isDetailsTab || this.isApplicationInfo) {
                this.switchToApplicationTab()
            } else {
                window.scrollTo(0, 160);
                this.focusFirstInput();
            }
        },

        trackBottomGetConnectedBtn(el) {
            if (window.innerWidth < 1024 && (this.isDetailsTab || this.isApplicationInfo)) {
                if (el.type === 'enter') {
                    this.$refs.btnGetConnected.classList.add('hidden');
                } else if (el.type === 'exit') {
                    this.$refs.btnGetConnected.classList.remove('hidden');
                }
            }
        },

        trackFixedGetConnectedBtn(el) {
            if (window.innerWidth < 1024 && (this.isDetailsTab || this.isApplicationInfo)) {
                if(el.percentTop >= 1) {
                    this.$refs.btnGetConnected.classList.remove('hidden');
                }else if (el.percentTop <= 0) {
                    this.$refs.btnGetConnected.classList.remove('hidden');
                }
            }
        },

        handleCompanyColorOnMedia() {
            const interval = setInterval(() => {
                const perkContainer = this.$refs.perkContainer;

                if (perkContainer) {
                    const companyColor = perkContainer.getAttribute('cl-color');

                    const iconsGFill = perkContainer.querySelectorAll(`.company-perks-container .icon-wrapper > svg g[fill^="#"]`);
                    const iconsGStroke = perkContainer.querySelectorAll(`.company-perks-container .icon-wrapper > svg g[stroke^="#"]`);
                    const iconsPathFill = perkContainer.querySelectorAll(`.company-perks-container .icon-wrapper > svg path[fill^="#"]`);

                    if (iconsGFill.length > 0) {
                        iconsGFill.forEach((child) => {
                            child.style.fill = companyColor;
                            child.setAttribute('fill', companyColor);
                        });
                    }

                    if (iconsGStroke.length > 0) {
                        iconsGStroke.forEach((child) => {
                            child.style.stroke = companyColor;
                            child.setAttribute('stroke', companyColor);
                        });
                    }

                    if (iconsPathFill.length > 0) {
                        iconsPathFill.forEach((child) => {
                            child.style.fill = companyColor;
                            child.setAttribute('fill', companyColor);
                        });
                    }

                    clearInterval(interval)
                }
            }, 50)
        },
    }
}
</script>

<style lang="scss" scoped>
    .tab-item {
        border-bottom: 2px solid var(--company-color);
        color: var(--company-color) !important;
    }
</style>